/**
 * Crisis-language detector for free-text user input.
 *
 * Conservative keyword match against a small list of self-harm / suicide /
 * acute-distress phrases. Avoids regex flexibility because false positives in
 * a calm reflection are worse than a missed soft signal — a user who genuinely
 * needs help will usually pair these phrases with extra context.
 *
 * NOT a substitute for clinical screening. Used only to surface a resource
 * panel alongside the standard save flow.
 */

const PHRASES: readonly string[] = [
  'kill myself',
  'killing myself',
  "don't want to be here",
  'do not want to be here',
  'want to die',
  'end it all',
  'end my life',
  'suicide',
  'suicidal',
  'self harm',
  'self-harm',
  'hurt myself',
  'cut myself',
  'no reason to live',
  "can't go on",
  'cannot go on',
];

export function containsCrisisLanguage(text: string | undefined | null): boolean {
  if (!text) return false;
  const lower = text.toLowerCase();
  return PHRASES.some((p) => lower.includes(p));
}
